import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e64ab4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolving-limitation-step-one" }
const _hoisted_2 = { class: "resolving-limitation-step-one__camera-box" }
const _hoisted_3 = {
  class: "resolving-limitation-step-one__desktop-camera",
  ref: "desktopCameraRef",
  muted: ""
}
const _hoisted_4 = {
  key: 0,
  class: "resolving-limitation-step-one__timer"
}
const _hoisted_5 = {
  key: 0,
  class: "resolving-limitation-step-one__avatar"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "142",
  height: "142"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M136.852 141.61v-7.176c.317-19.054-14.848-34.773-33.907-35.145h-12.85L71 116.568 51.905 99.289H39.054c-19.059.372-34.224 16.091-33.906 35.145v7.176H.444v-7.176c0-21.978 17.321-39.847 38.61-39.847h14.664L71 110.224l17.281-15.637h14.664c21.289 0 38.611 17.869 38.611 39.847v7.176h-4.704zm-28.371-82.483c-.849 19.9-17.289 35.565-37.213 35.46h-.536c-19.925.105-36.364-15.56-37.214-35.46l-.842-20.043a36.551 36.551 0 0 1 10.25-27.066A37.027 37.027 0 0 1 69.89.542h2.22a37.03 37.03 0 0 1 26.964 11.476 36.55 36.55 0 0 1 10.249 27.066l-.842 20.043zm-70.264-.197c.751 17.379 15.114 31.053 32.515 30.955h.536c17.405.102 31.774-13.578 32.521-30.962l.471-11.358a27.536 27.536 0 0 1-22.458-17.841C76.411 35.999 63.208 47.21 37.747 47.79l.47 11.14zm57.461-43.658A32.365 32.365 0 0 0 72.11 5.244h-2.22a32.365 32.365 0 0 0-23.568 10.028 31.895 31.895 0 0 0-8.954 23.615l.174 4.189c32.054-.719 43.046-19.568 43.155-19.763a2.351 2.351 0 0 1 4.386.853 22.857 22.857 0 0 0 19.367 18.652l.165-3.931a31.9 31.9 0 0 0-8.937-23.615z"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "resolving-limitation-step-one__text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "resolving-limitation-step-one__heading" }, "توجه کنید:", -1))
const _hoisted_10 = { class: "text-secondary mb-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M20.223 1.96a6.53 6.53 0 0 0-9.219 0l-9.021 9.013a5.09 5.09 0 0 0 0 7.207 5.11 5.11 0 0 0 7.213 0l9.022-9.014a3.682 3.682 0 0 0 0-5.204 3.691 3.691 0 0 0-5.209 0L5.315 11.65a.847.847 0 1 0 1.199 1.198l7.694-7.688a1.992 1.992 0 0 1 2.811 0 1.988 1.988 0 0 1 0 2.809l-9.022 9.013a3.41 3.41 0 0 1-4.815 0 3.397 3.397 0 0 1 0-4.811l9.021-9.014a4.824 4.824 0 0 1 6.821 0 4.815 4.815 0 0 1 0 6.815l-4.01 4.006a.847.847 0 1 0 1.199 1.198l4.01-4.006a6.517 6.517 0 0 0 0-9.21z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.permissionError)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.permissionError = false)),
          variant: "danger",
          title: "دسترسی وبکم با مشکل مواجه شد"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        ref: "cameraRef",
        type: "file",
        accept: "video/*",
        capture: "camera",
        class: "d-none",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCameraInputChange && _ctx.onCameraInputChange(...args)))
      }, null, 544),
      _createElementVNode("input", {
        ref: "inputFileRef",
        type: "file",
        accept: "video/*",
        class: "d-none",
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onCameraInputChange && _ctx.onCameraInputChange(...args)))
      }, null, 544),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("video", _hoisted_3, null, 512), [
          [_vShow, _ctx.isCameraOpen]
        ]),
        (_ctx.isCameraOpen && _ctx.timer > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.timer), 1))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isCameraOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("p", _hoisted_10, [
          _createTextVNode(" لطفا یک فایل ویدئویی با کیفیت همراه با نور مناسب مطابق راهنما تهیه و آپلود نمایید. "),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$parent.$emit('help'))),
            class: "resolving-limitation-step-one__help-btn"
          }, " راهنمای تهیه فایل ")
        ])
      ]),
      (!_ctx.isMobileAgent() && !_ctx.isCameraOpen)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "resolving-limitation-step-one__record-btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCamera && _ctx.openCamera(...args)))
          }))
        : (!_ctx.isMobileAgent() && _ctx.isCameraOpen && _ctx.timer === 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "resolving-limitation-step-one__stop-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args)))
            }))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "resolving-limitation-step-one__record-btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cameraRef && _ctx.cameraRef.click()))
            })),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputFileRef && _ctx.inputFileRef.click())),
        class: "resolving-limitation-step-one__upload-btn"
      }, [
        _hoisted_11,
        _createTextVNode(" آپلود فایل تصویری ")
      ])
    ])
  ], 64))
}